import PropTypes from 'prop-types'

import { ADDRESS_STATES } from '../common/constants'

const timeSlotPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired,
  disabled: PropTypes.bool,
})
export const timeSlotOptionsPropType = PropTypes.arrayOf(timeSlotPropType)

export const addressPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
})

export const autocompleteAddressPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  autocompleteAddress: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  streetNumber: PropTypes.string.isRequired,
  stair: PropTypes.string,
  floor: PropTypes.string,
  letter: PropTypes.string,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string,
})

//TEMP
export const addressPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  postalCode: PropTypes.shape({
    postalCode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
  }),
  phone: PropTypes.string,
})

export const googleAddressPropTypes = PropTypes.shape({
  name: PropTypes.string,
  country: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  streetNumber: PropTypes.string.isRequired,
  floor: PropTypes.string.isRequired,
  stair: PropTypes.string,
  letter: PropTypes.string,
})

export const shippingSendMobilePropTypes = PropTypes.shape({
  centerCode: PropTypes.string,
  destination: addressPropTypes,
})

export const i18nMessage = PropTypes.shape({
  key: PropTypes.string.isRequired,
  values: PropTypes.object,
})

export const loginPropTypes = {
  user: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
}

export const requestPasswordResetPropTypes = {
  email: PropTypes.string.isRequired,
}

export const resetPasswordPropTypes = {
  password: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
}

export const firstVisitResetPasswordPropTypes = {
  password: PropTypes.string,
}

// PropType enhancer. Given a propType (generally used with is `isRequired`)
// it allows `null` as a value.
export const nullablePropType =
  propType =>
  (props, propName, componentName, ...rest) => {
    if (props[propName] !== null) {
      return propType(props, propName, componentName, ...rest)
    }
  }

export const stepper = {
  states: PropTypes.object.isRequired,
  currentStep: PropTypes.string.isRequired,
  onClickStep: PropTypes.func.isRequired,
}

export const shippingSend1FromPropTypes = {
  client: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }),
  name: PropTypes.string,
  address: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autocompleteAddress: PropTypes.string,
  floor: PropTypes.string,
  letter: PropTypes.string,
  stair: PropTypes.string,
  route: PropTypes.string,
  streetNumber: PropTypes.string,
  country: PropTypes.string,
  postalCode: PropTypes.string,
  city: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  pickUpDate: PropTypes.instanceOf(Date),
  pickUpTimetable: PropTypes.string,
  pickUpTimeSlot: PropTypes.string,
  comments: PropTypes.string,
  addressState: PropTypes.oneOf(Object.values(ADDRESS_STATES)),
}

export const shippingSend2ToPropTypes = {
  name: PropTypes.string,
  address: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autocompleteAddress: PropTypes.string,
  floor: PropTypes.string,
  letter: PropTypes.string,
  stair: PropTypes.string,
  route: PropTypes.string,
  streetNumber: PropTypes.string,
  country: PropTypes.string,
  postalCode: PropTypes.string,
  city: PropTypes.string,
  phone: PropTypes.string,
  phonePrefix: PropTypes.string,
  email: PropTypes.string,
  comments: PropTypes.string,
  isNewDirection: PropTypes.bool,
}

export const shippingSend3ShipmentPropTypes = {
  serviceType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hasCustom: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  referenceNumber: PropTypes.string,
  packages: {
    type: 'arrayOf',
    of: {
      type: 'shape',
      shape: {
        weight: PropTypes.number,
        length: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number,
      },
    },
  },
  
  selectedBtn: PropTypes.number,

  documentInfo: PropTypes.shape({
    documentType: PropTypes.string,
    taricCode: PropTypes.number,
    originOfGoods: PropTypes.string,
    natureOfGoods: PropTypes.string,
    units: PropTypes.number,
    valueOfGoods: PropTypes.number,
    currencyValueOfGoods: PropTypes.string,
  }),
  additionals: PropTypes.shape({
    declaredValue: PropTypes.number,
    withRefund: PropTypes.bool,
    refundAmount: PropTypes.number,
    insuranceMerchandise: PropTypes.bool,
    insuranceValue: PropTypes.number,
    withReturn: PropTypes.bool,
    returnWithHandling: PropTypes.bool,
    item2: PropTypes.bool,
    scanClientSlip: PropTypes.bool,
    item3: PropTypes.bool,
    verifyCode: PropTypes.bool,
  }),
}

export const shippingSendCustomShipmentPropTypes = {
  wasSubmit: PropTypes.bool,
  senderType: PropTypes.string.isRequired,
  receptorType: PropTypes.string.isRequired,
  senderInfo: PropTypes.shape({
    dni: PropTypes.string,
    reason: PropTypes.string,
    companyName: PropTypes.string,
    nifIva: PropTypes.string,
    bill: PropTypes.string,
  }).isRequired,
  receptorInfo: PropTypes.shape({
    dni: PropTypes.string,
    companyName: PropTypes.string,
    nifIva: PropTypes.string,
  }).isRequired,
}

export const mobileShippingsTable = PropTypes.arrayOf(
  PropTypes.shape({
    info: PropTypes.shape({
      shippingCode: PropTypes.string,
      recipientAddress2: PropTypes.string,
      date: PropTypes.string,
      shippingStatusCode: PropTypes.shape({
        canCancel: PropTypes.bool,
        name: PropTypes.string,
        reason: PropTypes.string,
        severity: PropTypes.string.isRequired,
        code: PropTypes.string,
      }),
    }),
  }),
)
